import axios from 'axios'
import moment from 'moment'

const state = {
    newsfeeds: {},
    isLoadingTable: false,
    showDeleteModal: false,
    newsfeed: {}
}

const mutations = {
    getPaginatedNewsfeeds(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/newsfeeds/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            response.data.data.forEach(d=>{
                d.date = moment(d.date).format('MM/DD/YYYY')
                d.dateCreated = moment(d.dateCreated).format('MM/DD/YYYY HH:ss')
            })
            state.newsfeeds = response.data
        }).catch(error => {
            // eslint-disable-next-line no-console
            console.log(error)
        }).then(() => {
            state.isLoadingTable = false
        })
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.newsfeed) {
            state.newsfeed = payload.newsfeed
        } else {
            state.newsfeed = {}
        }
    }
}

const actions = {
    getPaginatedNewsfeeds({
        commit
    }, payload) {
        commit('getPaginatedNewsfeeds', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}